/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Table, Tooltip, notification } from 'antd';
import { Button as CrceButton, DatePicker as CrceDatePicker } from '@crc-evans/ui-components';
import { FileText, MessageSquare, X } from 'lucide-react';
import { fetchDsrLogs } from '../redux/dsr/action';
import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';
import { fetchToolBoxHome } from '../redux/toolbox/action';
import ToolBoxDetails from './DSR/ToolBoxDetails';
import './ToolboxHome.css';
import './ShippingManagement/ShipmentDashBoardPage.css';
import { getProjectTableLoadingConfig } from './ProjectTableLoader';
import { ProjectTabTableEmpty } from './project/ProjectTabTableEmpty';

const ToolboxHome = (props) => {
  const { selectedProject, onFetchDsrLogs, onFetchToolBox, toolBoxData, isToolboxLoading } = props;
  const dsrLog = toolBoxData.sort((a, b) => new Date(b.meetingTime) - new Date(a.meetingTime));

  const [isAddMemberVisible, setIsAddMemberVisible] = useState(false);
  const [communicationsDateFrom, setCommunicationsDateFrom] = useState('');
  const [communicationsDateTo, setCommunicationsDateTo] = useState('');
  const [communicationRegisterId, setCommunicationRegisterId] = useState('');
  const [title, setTitle] = useState('');
  const [fileVersion, setFileVersion] = useState('');
  const [communicationsPage, setCommunicationsPage] = useState(1);
  const [communicationsPageSize, setCommunicationsPageSize] = useState(10);

  const resetCommunicationsFilterToToday = () => {
    const today = new Date();
    const formattedStartDate = today.toISOString().split('T')[0];
    const data = {
      selectedProject: selectedProject,
      startDate: formattedStartDate,
      endDate: formattedStartDate,
    };
    onFetchToolBox(data);
  };

  useEffect(() => {
    if (selectedProject && selectedProject.id) {
      const today = new Date();
      const formattedStartDate = today.toISOString().split('T')[0];
      const data = {
        selectedProject: selectedProject,
        startDate: formattedStartDate,
        endDate: formattedStartDate,
      };
      onFetchToolBox(data);
      setCommunicationsDateFrom('');
      setCommunicationsDateTo('');
    }
  }, [selectedProject]);

  const communicationTypes = [
    { code: 'SA', label: 'Safety Alert' },
    { code: 'TB', label: 'Toolbox Talk' },
    { code: 'EN', label: 'Engineering Notification' },
    { code: 'QA', label: 'Quality Alert' },
    { code: 'EA', label: 'Environmental Alert' },
    { code: 'RA', label: 'Risk Assessments' },
  ];

  const columns = [
    {
      title: 'Date',
      dataIndex: 'meetingTime',
      key: 'date',
      render: (text, record) => {
        return (
          <button
            type="button"
            className="communications-row-date"
            onClick={() => {
              showModal(record);
            }}
          >
            {text ? moment.utc(text).format('DD MMM YYYY') : '-'}
          </button>
        );
      },
      align: 'center',
    },
    {
      title: 'Title',
      key: 'title',
      align: 'left',
      ellipsis: {
        showTitle: false,
      },
      render: (data, record) => truncateTableData(record.title),
    },
    {
      title: 'Type',
      dataIndex: 'communicationType',
      key: 'communicationType',
      align: 'left',
      ellipsis: {
        showTitle: false,
      },
      render: (data) => {
        const foundType = communicationTypes.find((type) => type.code === data);
        return foundType ? foundType.label : data;
      },
    },
    {
      title: 'Presented By',
      key: 'presenterName',
      render: (text, record) => {
        return <div>{record.presenterName}</div>;
      },
      align: 'center',
    },
    {
      title: 'Report',
      dataIndex: 'reportDetails',
      key: 'reportDetails',
      align: 'center',
      render: (text, record) => {
        return (
          <>
            {record &&
            record.reportDetails !== null &&
            JSON.stringify(record.reportDetails) != '{}' ? (
              <Tooltip title="View / Download Report">
                <a
                  href={record?.reportDetails?.fileUrl}
                  className="communications-doc-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="View or download report"
                >
                  <FileText size={18} strokeWidth={1.75} />
                </a>
              </Tooltip>
            ) : (
              <Tooltip title="Report Not Generated">
                <span className="communications-doc-link is-disabled" aria-hidden>
                  <FileText size={18} strokeWidth={1.75} />
                </span>
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  const truncateTableData = (data) => {
    return (
      <Tooltip placement="topLeft" title={data}>
        {data}
      </Tooltip>
    );
  };

  const showModal = (record) => {
    setTitle(record?.title);
    setFileVersion(record?.fileVersion);
    setIsAddMemberVisible(true);
    setCommunicationRegisterId(record?.communicationRegisterId);
  };

  const handleCancel = () => {
    setIsAddMemberVisible(false);
  };

  const runFetchForDateRangeStrings = (fromStr, toStr) => {
    if (!fromStr || !toStr) return;
    const startM = moment.min(moment(fromStr), moment(toStr));
    const endM = moment.max(moment(fromStr), moment(toStr));
    const dateObj = {
      fromDate: startM.format('YYYY-MM-DD HH:mm:ss'),
      toDate: endM.format('YYYY-MM-DD HH:mm:ss'),
    };
    if (selectedProject && selectedProject.id) {
      onFetchDsrLogs({ selectedProject, dateObj });
      onFetchToolBox({
        selectedProject,
        startDate: dateObj.fromDate,
        endDate: dateObj.toDate,
      });
    } else {
      notification.warning({
        message: 'Please select Project to create Pipeline',
      });
    }
  };

  const handleCommunicationsDatePartChange = (which, value) => {
    const nextFrom = which === 'from' ? value || '' : communicationsDateFrom;
    const nextTo = which === 'to' ? value || '' : communicationsDateTo;
    setCommunicationsDateFrom(nextFrom);
    setCommunicationsDateTo(nextTo);

    if (!nextFrom && !nextTo) {
      resetCommunicationsFilterToToday();
      return;
    }
    if (nextFrom && nextTo) {
      runFetchForDateRangeStrings(nextFrom, nextTo);
    }
  };

  const handleCommunicationsDateRangeReset = () => {
    setCommunicationsDateFrom('');
    setCommunicationsDateTo('');
    resetCommunicationsFilterToToday();
  };

  return (
    <div className="modern-communications-page">
      <div className="communications-header">
        <div className="communications-header-text">
          <div className="communications-header-icon" aria-hidden>
            <MessageSquare size={22} color="#00a88e" />
          </div>
          <div className="communications-header-titles">
            <h1 className="communications-title">Communications</h1>
            <p className="communications-subtitle">List of communications for this project.</p>
          </div>
        </div>
        <div className="communications-toolbar">
          <div className="communications-date-range" role="group" aria-label="Filter by date range">
            <div className="communications-crce-field">
              <span className="communications-crce-field-label" id="communications-from-label">
                From
              </span>
              <CrceDatePicker
                className="communications-crce-date"
                size="medium"
                placeholder="Start date"
                value={communicationsDateFrom}
                max={communicationsDateTo || undefined}
                onChange={(v) => handleCommunicationsDatePartChange('from', v)}
              />
            </div>
            <span className="communications-date-range-sep" aria-hidden>
              –
            </span>
            <div className="communications-crce-field">
              <span className="communications-crce-field-label" id="communications-to-label">
                To
              </span>
              <CrceDatePicker
                className="communications-crce-date"
                size="medium"
                placeholder="End date"
                value={communicationsDateTo}
                min={communicationsDateFrom || undefined}
                onChange={(v) => handleCommunicationsDatePartChange('to', v)}
              />
            </div>
            {(communicationsDateFrom || communicationsDateTo) && (
              <CrceButton
                label="Reset"
                variant="tertiary"
                size="medium"
                onClick={handleCommunicationsDateRangeReset}
              />
            )}
          </div>
        </div>
      </div>

      <div className="communications-table-shell">
        <Table
          columns={columns}
          dataSource={[...dsrLog]}
          className="communications-dashboard-table"
          rowKey={(r) => r.communicationRegisterId ?? r.id ?? `${r.meetingTime}-${r.title}`}
          scroll={{ x: 900, y: 'calc(100vh - 320px)' }}
          loading={getProjectTableLoadingConfig(isToolboxLoading)}
          locale={{ emptyText: <ProjectTabTableEmpty /> }}
          pagination={
            dsrLog.length > 0
              ? {
                  position: ['bottomCenter'],
                  className: 'heat-profile-pagination',
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '50', '100'],
                  showTotal: (total, range) => `${range[0]}–${range[1]} of ${total} items`,
                  total: dsrLog.length,
                  current: communicationsPage,
                  pageSize: communicationsPageSize,
                  onChange: (page, size) => {
                    setCommunicationsPage(page);
                    setCommunicationsPageSize(size);
                  },
                }
              : false
          }
        />
      </div>

      {isAddMemberVisible && (
        <div
          className="mc-dpr-modal-backdrop"
          role="presentation"
          onClick={(e) => {
            if (e.target === e.currentTarget) handleCancel();
          }}
        >
          <div
            className="mc-dpr-modal mc-dpr-modal--communications-detail"
            role="dialog"
            aria-labelledby="communications-detail-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mc-dpr-modal-head">
              <h3 id="communications-detail-modal-title" className="mc-dpr-modal-title">
                <span className="communications-detail-modal-title">
                  {title ? title : ''}
                  {' — '}
                  Version {fileVersion ? fileVersion : ''}
                </span>
              </h3>
              <button
                type="button"
                className="mc-dpr-modal-close"
                aria-label="Close"
                onClick={handleCancel}
              >
                <X size={20} />
              </button>
            </div>
            <div className="mc-dpr-modal-body">
              <ToolBoxDetails communicationRegisterId={communicationRegisterId} />
            </div>
            <div className="mc-dpr-modal-foot">
              <CrceButton label="Cancel" variant="tertiary" size="medium" onClick={handleCancel} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ dsrReducer, toolBoxReducer }) => {
  const dsrLogs = get(dsrReducer, 'dsrLogsList', []);
  const isToolboxLoading = get(toolBoxReducer, 'isFetchtoolBoxDataLoading', []);
  const toolBoxData = get(toolBoxReducer, 'toolBoxHomeData', []);

  return {
    dsrLogs,
    isToolboxLoading,
    toolBoxData,
  };
};

const mapDispatchToProps = {
  onFetchDsrLogs: fetchDsrLogs,
  onFetchToolBox: fetchToolBoxHome,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolboxHome);
